<template>
  <a-menu-item key="3" @click="showReviewProjectQuestModal">
    <FormOutlined />&nbsp;填寫狀況&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="90%" title="專案問卷 填寫狀況預覽" 
      style="top: 30px; bottom: 30px;" :maskClosable="isMaskClosable">
    <template #footer>
      <a-button type="primary" @click="closeProjectReview">關閉</a-button>
    </template>
    <a-tabs v-model:activeKey="selectedTab" size="default">
        <a-tab-pane key="import">
            <template #tab>
              <span>
                <CheckCircleOutlined />已匯入人員問卷預覽
              </span>
            </template>
            <a-space>
                <a-tag :bordered="false" color="volcano">專案編號</a-tag>{{ formState.projectNo }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="volcano">專案名稱</a-tag>{{ formState.projectName }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="volcano">客戶名稱</a-tag>{{ formState.companyName }}
            </a-space>
            <a-table style="width: 100%;" 
                :loading="isLoading"
                :columns="importTableColumns" 
                :data-source="formState.import.questDetails" 
                :row-selection="{ selectedRowKeys: formState.import.selectedUsers, onChange: onImportSelectChange }">
                <template #title>
                  <a-space direction="vertical">
                    <a-space-compact>
                        匯入總人數：{{ formState.import.total }}&nbsp;人
                    </a-space-compact>
                    <a-space-compact>
                        已完成人數：{{ formState.import.completed }}&nbsp;人
                    </a-space-compact>
                    <a-space-compact>
                        未完成人數：{{ formState.import.unCompleted }}&nbsp;人
                    </a-space-compact>
                    <a-space size="middle">
                      <a-button type="primary" :disabled="!importUserQuestExist()" @click="exportImportUserQuestResults()">
                        <DownloadOutlined />&nbsp;匯出填寫狀況
                      </a-button>
                      <a-button type="primary" :disabled="!isSelectImportUser()" @click="deleteSelectedImportUser()">
                        <DeleteOutlined />&nbsp;刪除已選取人員
                      </a-button>
                      <a-input-search v-model:value="formState.searchText" @change="onSearchChange" 
                        placeholder="輸入搜尋文字" style="width: 260px; float: right;" @search="reloadProjectQuests"/>
                    </a-space>
                  </a-space>
                </template>
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'personalNo'">
                    {{ common.getDisplayPersonalNo(record.personalNo) }}
                  </template>
                  <template v-if="column.key === 'questStatus'">
                    <span v-for="userQuestResult in record.userQuestResults" :key="userQuestResult">
                      <template v-if="userQuestResult.finishDate != null">
                          <a-button type="link" @click="openQuestReviewPage(userQuestResult.questType, record.personalNo)">
                            <ExportOutlined />{{ userQuestResult.questName }}({{ userQuestResult.finishDate }})
                          </a-button>
                      </template>
                      <template v-if="userQuestResult.finishDate == null">
                          <a-button type="link" disabled>{{ userQuestResult.questName }}</a-button>
                      </template>
                    </span>
                  </template>
                <template v-else-if="column.key === 'action'">
                    <a-dropdown :trigger="['click']">
                    <template #overlay>
                      <a-menu>
                        <edit-project-user-modal :project-url="props.project.url" :project-quest-user="record" @submit-success="editProjectUserSuccess" />
                        <a-menu-item key="deleteProjectUser" @click="deleteProjectUser(record)">
                            <DeleteOutlined />&nbsp;刪除人員&nbsp;
                        </a-menu-item>
                        <move-to-project-modal :project="props.project" :user-record="record" @submit-success="reloadProjectQuests" />
                      </a-menu>
                    </template>
                    <a-button>更多&nbsp;<DownOutlined /></a-button>
                    </a-dropdown>
                </template>
                </template>
                <template #footer>
                  <a-button type="primary" :disabled="!isSelectImportUser()" @click="deleteSelectedImportUser()">
                      <DeleteOutlined />&nbsp;刪除已選取人員
                  </a-button>
                </template>
            </a-table>
        </a-tab-pane>
        <a-tab-pane key="unImport">
            <template #tab>
              <span>
                <ExclamationCircleOutlined />未匯入人員問卷預覽
              </span>
            </template>
            <a-space>
                <a-tag :bordered="false" color="volcano">專案編號</a-tag>{{ formState.projectNo }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="volcano">專案名稱</a-tag>{{ formState.projectName }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="volcano">客戶名稱</a-tag>{{ formState.companyName }}
            </a-space>
            <a-table style="width: 100%;" 
                :loading="isLoading"
                :columns="unImportTableColumns" 
                :data-source="formState.unImport.questDetails" 
                :row-selection="{ selectedRowKeys: formState.unImport.selectedUsers, onChange: onUnImportSelectChange }">
                <template #title>
                  <a-space direction="vertical">
                    <a-space-compact>
                        未匯入總人數：{{ formState.unImport.total }}&nbsp;人
                    </a-space-compact>
                    <a-space-compact>
                        已完成人數：{{ formState.unImport.completed }}&nbsp;人
                    </a-space-compact>
                    <a-space-compact>
                        未完成人數：{{ formState.unImport.unCompleted }}&nbsp;人
                    </a-space-compact>
                    <a-space size="middle">
                      <a-button type="primary" :disabled="!unImportUserQuestExist()" @click="downloadUnImportUsers()">
                        <DownloadOutlined />&nbsp;下載未匯入名單
                      </a-button>
                      <a-button type="primary" :disabled="!isSelectUnImportUser()" @click="deleteSelectedUnImportQuest()">
                        <DeleteOutlined />&nbsp;刪除已選取問卷
                      </a-button>
                      <a-input-search v-model:value="formState.searchText" @change="onSearchChange" 
                        placeholder="輸入搜尋文字" style="width: 260px; float: right;" @search="reloadProjectQuests"/>
                    </a-space>
                  </a-space>
                </template>
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'questStatus'">
                      <span v-for="userQuestResult in record.userQuestResults" :key="userQuestResult">
                        <template v-if="userQuestResult.finishDate != null">
                            <a-button type="link" @click="openQuestReviewPage(userQuestResult.questType, record.personalNo)"><ExportOutlined />{{ userQuestResult.questName }}({{ userQuestResult.finishDate }})</a-button>
                        </template>
                        <template v-if="userQuestResult.finishDate == null">
                            <a-button type="link" disabled>{{ userQuestResult.questName }}</a-button>
                        </template>
                      </span>
                  </template>
                  <template v-else-if="column.key === 'action'">
                      <a-dropdown :trigger="['click']">
                      <template #overlay>
                          <a-menu>
                            <update-personal-no-modal :project-url="props.project.url" :project-quest-user="record" @submit-success="reloadProjectQuests"/>
                            <new-project-user-modal :project-url="props.project.url" :personal-no="record.personalNo" @submit-success="reloadProjectQuests"/>
                            <a-menu-item key="deleteUserQuest" @click="deleteUnImportUserQuest(record)">
                              <DeleteOutlined />&nbsp;刪除人員問卷&nbsp;
                            </a-menu-item>
                            <move-to-project-modal :project="props.project" :user-record="record" @submit-success="reloadProjectQuests" />
                          </a-menu>
                      </template>
                      <a-button>更多&nbsp;<DownOutlined /></a-button>
                      </a-dropdown>
                  </template>
                </template>
                <template #footer>
                  <a-button type="primary" :disabled="!isSelectUnImportUser()" @click="deleteSelectedUnImportQuest()">
                      <DeleteOutlined />&nbsp;刪除已選取問卷
                  </a-button>
                </template>
            </a-table>
        </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script setup>
import { DownloadOutlined, CheckCircleOutlined, ExclamationCircleOutlined, 
    DownOutlined, DeleteOutlined, FormOutlined, ExportOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { ref, reactive, defineProps } from 'vue';
import common from "@/common";
import config from "@/config";

import EditProjectUserModal from './EditProjectUserModal.vue';
import NewProjectUserModal from './NewProjectUserModal.vue';
import UpdatePersonalNoModal from './UpdatePersonalNoModal.vue';
import MoveToProjectModal from './MoveToProjectModal.vue';

const props = defineProps(['project']);

const isOpen = ref(false);
const formState = reactive({});
const isMaskClosable = ref(false);
const isLoading = ref(false);
const selectedTab = ref('import');

const importTableColumns = [
  {
    title: "證件編號",
    dataIndex: "personalNo",
    key: "personalNo",
    width: '150px'
  }, {
    title: "工/學號",
    dataIndex: "jobNo",
    key: "jobNo",
    width: '120px'
  }, {
    title: "健康編號",
    dataIndex: "healthNo",
    key: "healthNo",
    width: '120px'
  }, {
    title: "體檢人員姓名",
    dataIndex: "name",
    key: "name",
    width: '130px'
  }, {
    title: "問卷狀態",
    dataIndex: "questStatus",
    key: "questStatus",
    align: "left",
  }, {
    title: "動作",
    key: 'action',
    width: '140px'
  }];

const unImportTableColumns = [
  {
    title: "證件編號",
    dataIndex: "personalNo",
    key: "personalNo",
    width: '150px'
  }, {
    title: "問卷狀態",
    dataIndex: "questStatus",
    key: "questStatus",
    align: "left",
  }, {
    title: "動作",
    key: 'action',
    width: '140px'
  }];

const closeProjectReview = () => {
  isOpen.value = false;
}

const onSearchChange = () => {
  if (common.isNotEmpty(formState.searchText)) {
    return ;
  }
  reloadProjectQuests();
}

const getEmptyProjectQuestSummary = () => {
  return {
    total: 0,
    completed: 0,
    unCompleted: 0,
    questDetails: []
  };
}

const reloadProjectQuests = () => {
  isLoading.value = true;
  common.postRequest(config.mgmtProjectQuestSummaries, {
    projectUrl: props.project.url,
    searchText: formState.searchText
  }, (response) => {
    isLoading.value = false;
    formState.import = response.data.import;
    formState.unImport = response.data.unImport;
  }, () => {
    isLoading.value = false;
    formState.import = getEmptyProjectQuestSummary();
    formState.unImport = getEmptyProjectQuestSummary();
  });
}

const importUserQuestExist = () => {
  return formState.import.questDetails != null && formState.import.questDetails.length > 0;
}

const exportImportUserQuestResults = () => {
  isLoading.value = true;
  common.downloadFileByPosting(config.mgmtProjectQuestExportImportUserQuests, 
    props.project.companyName + "-填寫狀況.xlsx", {
      searchText: formState.searchText,
      projectUrl: props.project.url
    }, () => isLoading.value = false, () => {
      isLoading.value = false;
      message.error("匯出人員填寫狀況失敗，請重新登入！");
    })
}

const unImportUserQuestExist = () => {
  return formState.unImport.questDetails != null && formState.unImport.questDetails.length > 0;
}

const downloadUnImportUsers = () => {
  isLoading.value = true;
  common.downloadFileByPosting(config.projectUnImportDownloadXlsx + props.project.url, 
    props.project.companyName + "-未匯入人員清單.xlsx", {
      searchText: formState.searchText
    }, () => isLoading.value = false, () => {
      isLoading.value = false;
      message.error("下載未匯入人員失敗，請重新登入！");
    });
}

const showReviewProjectQuestModal = () => {
  formState.projectNo = props.project.projectNo;
  formState.projectName = props.project.projectName;
  formState.companyName = props.project.companyName;
  formState.searchText = "";
  formState.import = {};
  formState.unImport = {};
  isOpen.value = true;
  reloadProjectQuests();
}

const isSelectImportUser = () => {
  return formState.import.selectedUsers != null && 
    formState.import.selectedUsers.length > 0;
};

const isSelectUnImportUser = () => {
  return formState.unImport.selectedUsers != null &&
    formState.unImport.selectedUsers.length > 0;
}

const onImportSelectChange = selectedRowKeys => {
  formState.import.selectedUsers = selectedRowKeys;
};

const onUnImportSelectChange = selectedRowKeys => {
  formState.unImport.selectedUsers = selectedRowKeys;
};

const editProjectUserSuccess = (projectUserForm, projectQuestUser) => {
  projectQuestUser.name = projectUserForm.name;
  projectQuestUser.jobNo = projectUserForm.jobNo;
  projectQuestUser.healthNo = projectUserForm.healthNo;
}

const deleteProjectUser = (projectUser) => {
  common.openConfirmModal(500, '刪除確認', "是否確認刪除以下專案人員？(問卷資料仍會保留)\n" + 
        "證件編號「" + projectUser.personalNo + "」\n" + 
        "人員名稱「" + projectUser.name + "」", () => {
          return new Promise(function(resolve, reject) {
            common.postRequest(config.mgmtDeleteProjectUserEntity, {
              projectUrl: props.project.url,
              deletedProjectUsers: [projectUser.personalNo]
            }, () => {
              message.success("專案人員編號「" + projectUser.personalNo + "」，刪除成功。");
              resolve();
              reloadProjectQuests();
            }, () => {
              reject();
            });
          });
      });
}

const deleteSelectedImportUser = () => {
  let selectedUsersMsg = "";
  formState.import.selectedUsers.forEach((selectedUser) => 
  selectedUsersMsg = selectedUsersMsg.concat('\n', "證件編號「" + selectedUser + "」"));
  common.openConfirmModal(500, '刪除確認', "是否確認刪除以下所有專案人員？(問卷資料仍會保留)\n" + selectedUsersMsg, 
    () => {
      return new Promise(function(resolve, reject) {
        common.postRequest(config.mgmtDeleteProjectUserEntity, {
          projectUrl: props.project.url,
          deletedProjectUsers: formState.import.selectedUsers
        }, () => {
            message.success("所有選取之專案人員，刪除成功。");
            resolve();
            reloadProjectQuests();
          }, () => {
            reject();
          });
        });
    });
}

const deleteUnImportUserQuest = (record) => {
  common.openConfirmModal(550, '刪除確認', "是否確認刪除以下人員已完成填寫之問卷？\n" + 
    "證件編號「" + record.personalNo + "」", () => { 
      return new Promise(function(resolve, reject) {
        common.postRequest(config.mgmtProjectQuestDeleteUnImport, {
          projectUrl: props.project.url,
          deletedQuestUsers: [record.personalNo]
        }, () => {
          message.success("證件編號「" + record.personalNo + "」之問卷資料，刪除成功。");
          resolve();
          reloadProjectQuests();
        }, () => {
          reject();
        });
      });
    });
}

const deleteSelectedUnImportQuest = () => {
  let selectedUsersMsg = "";
  formState.unImport.selectedUsers.forEach((selectedUser) => 
    selectedUsersMsg = selectedUsersMsg.concat('\n', "證件編號「" + selectedUser + "」"));
  common.openConfirmModal(550, '刪除確認', "是否確認刪除以下所有人員已完成填寫之問卷？\n" + selectedUsersMsg, 
    () => {
      return new Promise(function(resolve, reject) {
        common.postRequest(config.mgmtProjectQuestDeleteUnImport, {
          projectUrl: props.project.url,
          deletedQuestUsers: formState.unImport.selectedUsers
        }, () => {
          message.success("所有選取人員之問卷，刪除成功。");
          resolve();
          reloadProjectQuests();
        }, () => {
          reject();
        });
      });
    });
}

const openQuestReviewPage = (questType, personalNo) => {
  common.postRequest(config.mgmtProjectQuestUserReviewUrl, {
    projectUrl: props.project.url,
    personalNo: personalNo,
    questType: questType
  }, (response) => window.open(response.data.reviewUrl, '_blank'));
}
</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
</style>